import type { App } from "@open-booking/server";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type CreateDepositPaymentResponse = App["~Routes"]["payments"]["bookings"][":id"]["deposit"]["post"]["response"]["200"];
type CreateRemainderPaymentResponse = App["~Routes"]["payments"]["bookings"][":id"]["remainder"]["post"]["response"]["200"];

export const tenantPaymentApi = createApi({
	reducerPath: "tenantPaymentApi",
	baseQuery: edenBaseQuery(),
	endpoints: (builder) => ({
		createDepositPayment: builder.mutation<CreateDepositPaymentResponse, string>({
			query:
				(bookingId): EdenCall<CreateDepositPaymentResponse> =>
				(client) =>
					client.payments.bookings({ id: bookingId }).deposit.post(),
		}),
		createRemainderPayment: builder.mutation<CreateRemainderPaymentResponse, string>({
			query:
				(bookingId): EdenCall<CreateRemainderPaymentResponse> =>
				(client) =>
					client.payments.bookings({ id: bookingId }).remainder.post(),
		}),
	}),
});

export const { useCreateDepositPaymentMutation, useCreateRemainderPaymentMutation } = tenantPaymentApi;
